import {
    ActivityStep,
    ActivityType,
    Question,
    Survey,
    Task,
    VisitOverlapTimeData,
    VisitSurvey,
} from '@/app/models/new-activity-creation-state'
import { newsForm } from '@/app/models/new-activity-news-form'
import { ActivitySection, NewActivitySectionType } from '@/app/models/new-activity-section-type'
import { taskCommunicationForm } from '@/app/models/new-activity-task-communication-form'
import { visitForm } from '@/app/models/new-activity-visit-form'
import { ProjectApiCreateActivityBody } from '@/app/models/projects-service'
import { ProjectsService } from '@/app/services/ProjectsService'
import {
    layoutActions,
    LayoutActivityType,
    ModalsType,
    SmartlyActionSubtypes,
} from '@Techedge/digitalportal-shared'
import { setIsPhotographicApprovalAccept, setProjectDetails } from './activity-execution'
import { digestFormDates } from '@/app/utils/activityAdapter'
import { FiltersService } from '@/app/services/FiltersService'
import { NEW_ACTIVITY_EXECUTION_NAMESPACE } from '../reducers/activity-execution'
import { useDispatch, useSelector } from 'react-redux'
import { selectProjectDetails } from '../selector/activity-execution'
import { Dispatch } from 'react'
import { AnyAction } from 'redux'

export const NewActivityCreationActions = {
    SET_ACTIVITY_STATUS: 'SET_ACTIVITY_STATUS',
    SET_ACTIVITY_KEY: 'SET_ACTIVITY_KEY',
    SET_ACTIVITY_TYPE_LIST: 'SET_ACTIVITY_TYPE_LIST',
    SET_FILTERS_DOMAIN: 'SET_FILTERS_DOMAIN',
    SET_ACTIVITY_SECTION_STATUS: 'SET_ACTIVITY_SECTION_STATUS',
    UPDATE_ANSWER_LIST: 'UPDATE_ANSWER_LIST',
    REMOVE_ANSWER: 'REMOVE_ANSWER',
    SET_QUESTION_STATUS: 'SET_QUESTION_STATUS',
    SET_NUMBER_OF_PHOTOS: 'SET_NUMBER_OF_PHOTOS',
    REMOVE_QUESTION: 'REMOVE_QUESTION',
    SET_TASK_STATUS: 'SET_TASK_STATUS',
    REMOVE_TASK: 'REMOVE_TASK',
    UPDATE_TASK_QUESTION_ANSWER_LIST: 'UPDATE_TASK_QUESTION_ANSWER_LIST',
    REMOVE_TASK_QUESTION_ANSWER: 'REMOVE_TASK_QUESTION_ANSWER',
    SET_TASK_QUESTION_STATUS: 'SET_TASK_QUESTION_STATUS',
    REMOVE_TASK_QUESTION: 'REMOVE_TASK_QUESTION',
    SET_SURVEY_STATUS: 'SET_SURVEY_STATUS',
    REMOVE_SURVEY: 'REMOVE_SURVEY',
    RESET_ACTION_LIST: 'RESET_ACTION_LIST',
    SET_NEW_ACTIVITY_FORM: 'SET_NEW_ACTIVITY_FORM',
    SET_CTA_TEMPLATE: 'SET_CTA_TEMPLATE',
    CREATE_AS_DRAFT: 'CREATE_AS_DRAFT',
    SAVE_AS_DRAFT: 'SAVE_AS_DRAFT',
    EDIT_SAVE_AS_DRAFT: 'EDIT_SAVE_AS_DRAFT',
    EDIT_SAVE_AS_TO_BE_RELEASED: 'EDIT_SAVE_AS_TO_BE_RELEASED',
    EDIT_RELEASE: 'EDIT_RELEASE',
    HISTORY_CHANGE: 'HISTORY_CHANGE',
    CLONE: 'CLONE',
    RELEASE: 'RELEASE',
    ASK_RELEASE: 'ASK_RELEASE',
    CREATE_AS_TO_BE_RELEASED: 'CREATE_AS_TO_BE_RELEASED',
    SAVE_AS_TO_BE_RELEASED: 'SAVE_AS_TO_BE_RELEASED',
    CANCEL: 'CANCEL',
    REJECT: 'REJECT',
    SAVE_AS_IN_PROGRESS: 'SAVE_AS_IN_PROGRESS',
    SAVE_AS_IN_APPROVAL: 'SAVE_AS_IN_APPROVAL',
    ACCEPT_PHOTOGRAPHIC_TASK: 'ACCEPT_PHOTOGRAPHIC_TASK',
    ACCEPT_APPROVAL_SERVICE_REQUEST_APPROVAL_DETAIL:
        'ACCEPT_APPROVAL_SERVICE_REQUEST_APPROVAL_DETAIL',
    ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK: 'ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK',
    DO_NOT_ACCEPT_PHOTOGRAPHIC_TASK: 'DO_NOT_ACCEPT_PHOTOGRAPHIC_TASK',
    DO_NOT_ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK: 'DO_NOT_ACCEPT_APPROVAL_PHOTOGRAPHIC_TASK',
    EDIT: 'EDIT',
    REDO_ALL: 'REDO_ALL',
    REDO: 'REDO',
    MARK_AS_READ: 'MARK_AS_READ',
    CLOSE_ALL: 'CLOSE_ALL',
    CLOSE_PROJECT: 'CLOSE_PROJECT',
    RECALL_PROJECT: 'RECALL_PROJECT',
    ADD_CHANGELOG: 'ADD_CHANGELOG',
    REMOVE_CHANGELOG: 'REMOVE_CHANGELOG',
    RESET_FORM: 'RESET_FORM',
    NEW_ACTIVITY_REQUEST: 'NEW_ACTIVITY_REQUEST',
    NEW_ACTIVITY_ERROR: 'NEW_ACTIVITY_FAILURE',
    NEW_ACTIVITY_SUCCESS: 'NEW_ACTIVITY_SUCCESS',
    SET_IS_ALL_STORE_SELECTED: 'SET_IS_ALL_STORE_SELECTED',
    SET_CHANGE_FIELDS: 'SET_CHANGE_FIELDS',
    SET_RESET_MANDATORY: 'SET_RESET_MANDATORY',
    SET_SCHEDULING_MIN_START_DATE: 'SET_SCHEDULING_MIN_START_DATE',
    SET_SCHEDULING_MAX_END_DATE: 'SET_SCHEDULING_MAX_END_DATE',
    SET_ACTIVITY_TYPE: 'SET_ACTIVITY_TYPE',
    ALBUM_PREVIEW: 'ALBUM_PREVIEW',
    ALBUM_SAVE: 'ALBUM_SAVE',
    REASSIGN: 'REASSIGN',
    SET_SMART_FILTER: 'SET_SMART_FILTER',
    SET_VISIT_SELECTED_SURVEYS: 'SET_VISIT_SELECTED_SURVEYS',
    SET_VISIT_SURVEY_LIST: 'SET_VISIT_SURVEY_LIST',
    GET_VISIT_SURVEY_LIST_REQUEST: 'GET_VISIT_SURVEY_LIST_REQUEST',
    GET_VISIT_SURVEY_LIST_FINALLY: 'GET_VISIT_SURVEY_LIST_FINALLY',
    SET_VISIT_OVERLAP_TIME_DATA: 'SET_VISIT_OVERLAP_TIME_DATA',
    SET_IS_ACTIVITY_TYPE_STEP: 'SET_IS_ACTIVITY_TYPE_STEP',
    SET_SELECTED_ACTIVITY_TYPE: 'SET_SELECTED_ACTIVITY_TYPE',
    SET_CURRENT_STEP: 'SET_CURRENT_STEP',
}

export const setCurrentStep = (payload: NewActivitySectionType) => {
    return {
        type: NewActivityCreationActions.SET_CURRENT_STEP,
        payload,
    }
}
export const setSelectedActivityType = (payload: Partial<ActivityType>) => {
    return {
        type: NewActivityCreationActions.SET_SELECTED_ACTIVITY_TYPE,
        payload,
    }
}
export const setIsActivityTypeStep = (payload: boolean) => {
    return {
        type: NewActivityCreationActions.SET_IS_ACTIVITY_TYPE_STEP,
        payload,
    }
}
export const setActivityStatus = (
    key: LayoutActivityType | string,
    value: boolean,
    disableReset?: boolean
) => {
    return {
        type: NewActivityCreationActions.SET_ACTIVITY_STATUS,
        payload: { key, value, disableReset },
    }
}
export const setActivityKey = (key: LayoutActivityType | string) => {
    return {
        type: NewActivityCreationActions.SET_ACTIVITY_KEY,
        payload: { key },
    }
}
export const setActivitySectionStatus = (
    activityKey: string,
    sectionKey: NewActivitySectionType,
    section: Partial<ActivityStep>
) => {
    return {
        type: NewActivityCreationActions.SET_ACTIVITY_SECTION_STATUS,
        payload: { activityKey, sectionKey, section },
    }
}
export const setActivityTypeList = (activityKey: string, typeList: any[]) => {
    return {
        type: NewActivityCreationActions.SET_ACTIVITY_TYPE_LIST,
        payload: { activityKey, typeList },
    }
}
export const setActivityType = (activityList: { key: string; icon: string; active?: boolean }) => {
    return {
        type: NewActivityCreationActions.SET_ACTIVITY_TYPE,
        payload: { activityList },
    }
}
export const setNewActivityForm = <T>(form: T, section: string, activityName: ActivitySection) => {
    return {
        type: NewActivityCreationActions.SET_NEW_ACTIVITY_FORM,
        payload: { form, section, activityName },
    }
}
export const resetForm = <T>(form: T, activityName: ActivitySection) => {
    return {
        type: NewActivityCreationActions.RESET_FORM,
        payload: { form, activityName },
    }
}
export const setCtaTemplate = (template) => {
    return { type: NewActivityCreationActions.SET_CTA_TEMPLATE, template }
}
export const setFiltersDomain = (banner, region, country) => {
    return {
        type: NewActivityCreationActions.SET_FILTERS_DOMAIN,
        payload: { banner, region, country },
    }
}
export const setIsAllStoreSelected = (value: boolean) => {
    return { type: NewActivityCreationActions.SET_IS_ALL_STORE_SELECTED, value }
}
// ACTIONS
export const resetActionList = (listName: string) => {
    return { type: NewActivityCreationActions.RESET_ACTION_LIST, listName }
}
// QUESTION ACTIONS
export const updateAnswerList = (
    questionIndex: number,
    index: number,
    value: string,
    disabled?: boolean
) => {
    return {
        type: NewActivityCreationActions.UPDATE_ANSWER_LIST,
        payload: { questionIndex, index, value, disabled },
    }
}
export const removeAnswer = (questionIndex: number, answerIndex: number) => {
    return {
        type: NewActivityCreationActions.REMOVE_ANSWER,
        payload: { questionIndex, answerIndex },
    }
}
export const removeQuestion = (index: number) => {
    return { type: NewActivityCreationActions.REMOVE_QUESTION, index }
}
export const setQuestionStatus = (index: number, question: Partial<Question>) => {
    return { type: NewActivityCreationActions.SET_QUESTION_STATUS, payload: { index, question } }
}
export const setNumberOfPhotos = (n: number) => {
    return { type: NewActivityCreationActions.SET_NUMBER_OF_PHOTOS, payload: { n } }
}

// TASK ACTIONS
export const setTaskStatus = (index: number, task: Partial<Task>) => {
    return { type: NewActivityCreationActions.SET_TASK_STATUS, payload: { index, task } }
}
export const removeTask = (index: number) => {
    return { type: NewActivityCreationActions.REMOVE_TASK, index }
}
// TASK QUESTION ACTIONS
export const updateTaskQuestionAnswerList = (
    taskIndex: number,
    questionIndex: number,
    answerIndex: number,
    value: string,
    disabled?: boolean
) => {
    return {
        type: NewActivityCreationActions.UPDATE_TASK_QUESTION_ANSWER_LIST,
        payload: { taskIndex, questionIndex, answerIndex, value, disabled },
    }
}
export const removeTaskQuestionAnswer = (
    taskIndex: number,
    questionIndex: number,
    answerIndex: number
) => {
    return {
        type: NewActivityCreationActions.REMOVE_TASK_QUESTION_ANSWER,
        payload: { taskIndex, questionIndex, answerIndex },
    }
}
export const removeTaskQuestion = (taskIndex: number, questionIndex: number) => {
    return {
        type: NewActivityCreationActions.REMOVE_TASK_QUESTION,
        payload: { taskIndex, questionIndex },
    }
}
export const setTaskQuestionStatus = (
    taskIndex: number,
    questionIndex: number,
    question: Partial<Question>
) => {
    return {
        type: NewActivityCreationActions.SET_TASK_QUESTION_STATUS,
        payload: { taskIndex, questionIndex, question },
    }
}
// SURVEY ACTIONS
export const setSurveyStatus = (index: number, survey: Partial<Survey>) => {
    return { type: NewActivityCreationActions.SET_SURVEY_STATUS, payload: { index, survey } }
}
export const removeSurvey = (index: number) => {
    return { type: NewActivityCreationActions.REMOVE_SURVEY, index }
}
// EDIT
export const addChangelog = (changelog: Record<string, string>) => {
    return { type: NewActivityCreationActions.ADD_CHANGELOG, changelog }
}
export const removeChangelog = (field: string) => {
    return { type: NewActivityCreationActions.REMOVE_CHANGELOG, field }
}

// REQUEST
export const newActivityCreationRequest = () => {
    return { type: NewActivityCreationActions.NEW_ACTIVITY_REQUEST }
}

export const newActivityCreationError = (error?: any) => {
    return {
        type: NewActivityCreationActions.NEW_ACTIVITY_ERROR,
        toastList: [
            {
                text: error,
            },
        ],
    }
}

export const newActivityCreationSuccess = (text) => {
    return {
        type: NewActivityCreationActions.NEW_ACTIVITY_SUCCESS,
        toastList: [
            {
                text,
            },
        ],
    }
}
export const setVisitOverlapTimeData = (visitOverlapTimeData: VisitOverlapTimeData) => {
    return {
        type: NewActivityCreationActions.SET_VISIT_OVERLAP_TIME_DATA,
        visitOverlapTimeData,
    }
}

export const resetAllForm = () => {
    return (dispatch: any) => {
        dispatch(setProjectDetails(null))
        dispatch(resetForm(newsForm, ActivitySection.NEWS_ACTIVITY))
        dispatch(resetForm(taskCommunicationForm, ActivitySection.TASK_ACTIVITY))
        dispatch(resetForm(visitForm, ActivitySection.VISIT_ACTIVITY))
        dispatch(resetActionList('questionList'))
        dispatch(resetActionList('taskList'))
        dispatch(resetActionList('surveyList'))
        dispatch(setIsPhotographicApprovalAccept(false))
        dispatch(setActivityStatus(LayoutActivityType.TASK, true))
        dispatch(
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.NEWS_TYPE,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.NEWS_TYPE,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.MAIN_INFO,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.MAIN_INFO,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.VISIT_ACTIVITY,
                NewActivitySectionType.MAIN_INFO,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.DISTRIBUTION,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(ActivitySection.TASK_ACTIVITY, NewActivitySectionType.ACTION, {
                isDone: false,
                isDirty: false,
            })
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.VISIT_ACTIVITY,
                NewActivitySectionType.ACTION,
                {
                    isDone: false,
                    isDirty: false,
                }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.DISTRIBUTION,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.NEWS_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.TASK_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: false, isDirty: false }
            )
        )
        dispatch(
            setActivitySectionStatus(
                ActivitySection.VISIT_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: false, isDirty: false }
            )
        )
    }
}

export const createSurveyTask = ({
    form,
    successMessage,
    callback,
}: {
    form: ProjectApiCreateActivityBody
    successMessage: string
    callback: () => void
}) => {
    return (dispatch: any) => {
        dispatch(newActivityCreationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.CreateActivity(form)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(newActivityCreationSuccess(successMessage))
                    dispatch(resetAllForm())
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                    callback()
                } else {
                    dispatch(newActivityCreationError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(newActivityCreationError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

export const createVisitProject = (
    form: ProjectApiCreateActivityBody,
    successMessage: string,
    errorMessage?: string
) => {
    return (dispatch: any) => {
        dispatch(newActivityCreationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.CreateActivity(form)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(newActivityCreationSuccess(successMessage))
                    dispatch(resetAllForm())
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(
                        newActivityCreationError(errorMessage || res.data.output.payload.message)
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                if (error.response?.data?.response?.overlappingTimeData) {
                    dispatch(
                        setVisitOverlapTimeData(error.response?.data?.response?.overlappingTimeData)
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                    return
                }
                dispatch(
                    newActivityCreationError(
                        errorMessage || error.response?.data?.message || error.message
                    )
                )
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

export const createProject = (
    form: ProjectApiCreateActivityBody,
    successMessage: string,
    errorMessage?: string
) => {
    return (dispatch: any) => {
        dispatch(newActivityCreationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))

        ProjectsService.CreateActivity(digestFormDates(form))
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(newActivityCreationSuccess(successMessage))
                    dispatch(resetAllForm())
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(
                        newActivityCreationError(errorMessage || res.data.output.payload.message)
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(
                    newActivityCreationError(
                        errorMessage || error.response?.data?.message || error.message
                    )
                )
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

export const releaseProject = (projectId: string, successMessage: string) => {
    return (dispatch: any) => {
        dispatch(newActivityCreationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.ReleaseProject(projectId)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(newActivityCreationSuccess(successMessage))
                    dispatch(resetAllForm())
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false, isEdit: false, isClone: false },
                        })
                    )
                } else {
                    dispatch(newActivityCreationError(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(newActivityCreationError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

export const rejectProject = (projectId: string, message: string, successMessage: string) => {
    return (dispatch: any) => {
        dispatch(newActivityCreationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.RejectProject(projectId, message)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(newActivityCreationSuccess(successMessage))
                } else {
                    dispatch(newActivityCreationError(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(newActivityCreationError(error.response?.data?.message || error.message))
            })
            .finally(() => {
                dispatch(resetAllForm())
                dispatch(
                    layoutActions.setModals({
                        type: null,
                        props: { id: null, loading: false, isEdit: false, isClone: false },
                    })
                )
            })
    }
}

export const historyChange = (
    newProject: any,
    invokeEditApi?: boolean,
    reasonChoice?: string[],
    reasonChange?: string,
    messageStores?: string,
    successMessage?: string,
    statusAction?: string
) => {
    return (dispatch: any) => {
        dispatch(newActivityCreationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.HistoryChange(newProject)
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(setChangeFields(res.data.changelog.changedFields || []))
                    dispatch(
                        setResetMandatory(
                            newProject.type !== SmartlyActionSubtypes.PICTURE_MGMT &&
                                invokeEditApi &&
                                res.data.changelog.isResetMandatory
                        )
                    )
                    if (
                        invokeEditApi &&
                        (!res.data.changelog.isResetMandatory ||
                            newProject.type === SmartlyActionSubtypes.PICTURE_MGMT)
                    ) {
                        dispatch(
                            editProject(
                                newProject,
                                reasonChoice,
                                reasonChange,
                                messageStores,
                                successMessage,
                                statusAction
                            )
                        )
                    } else {
                        dispatch(layoutActions.setModals({ props: { loading: false } }))
                    }
                } else {
                    dispatch(newActivityCreationError(res.data.output.payload.message))
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                }
            })
            .catch((error: any) => {
                dispatch(newActivityCreationError(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

export const editProject = (
    newProject: any,
    reasonChoice: string[],
    reasonChange: string,
    messageStores: string,
    successMessage: string,
    statusAction?: string
) => {
    return (dispatch: any) => {
        dispatch(newActivityCreationRequest())
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ProjectsService.EditProject(
            digestFormDates(newProject),
            reasonChoice,
            reasonChange,
            messageStores,
            statusAction
        )
            .then((res: any) => {
                if (res && res.data && !res.data.output) {
                    dispatch(newActivityCreationSuccess(successMessage))
                    dispatch(setResetMandatory(false))
                    dispatch(resetAllForm())
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: {
                                id: null,
                                loading: false,
                                isEdit: false,
                                isClone: false,
                                visit_id: null,
                                survey_id: null,
                            },
                        })
                    )
                } else {
                    dispatch(newActivityCreationError(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                if (error.response?.data?.response?.overlappingTimeData) {
                    dispatch(
                        setVisitOverlapTimeData(error.response?.data?.response?.overlappingTimeData)
                    )
                    dispatch(layoutActions.setModals({ props: { loading: false } }))
                    return
                }
                dispatch(newActivityCreationError(error.response?.data?.message || error.message))
            })
            .finally(() => dispatch(layoutActions.setModals({ props: { loading: false } })))
    }
}

export const setSmartFilterActivity = (value: any) => {
    return { type: NewActivityCreationActions.SET_SMART_FILTER, value }
}

// HISTORY CHANGE
export const setChangeFields = (value: any[]) => {
    return { type: NewActivityCreationActions.SET_CHANGE_FIELDS, value }
}
export const setResetMandatory = (value: boolean) => {
    return { type: NewActivityCreationActions.SET_RESET_MANDATORY, value }
}
export const setSchedulingMinStartDate = (value: number) => {
    return { type: NewActivityCreationActions.SET_SCHEDULING_MIN_START_DATE, value }
}
export const setSchedulingMaxEndDate = (value: number) => {
    return { type: NewActivityCreationActions.SET_SCHEDULING_MAX_END_DATE, value }
}

export const setVisitSelectedSurveys = (payload: VisitSurvey[]) => {
    return {
        type: NewActivityCreationActions.SET_VISIT_SELECTED_SURVEYS,
        payload,
    }
}
export const setVisitSurveyList = (payload: VisitSurvey[]) => {
    return {
        type: NewActivityCreationActions.SET_VISIT_SURVEY_LIST,
        payload,
    }
}
export const getVisitSurveyListRequest = () => {
    return {
        type: NewActivityCreationActions.GET_VISIT_SURVEY_LIST_REQUEST,
    }
}

export const getVisitSurveyList = (storeId: string) => {
    return (dispatch) => {
        dispatch((() => ({ type: NewActivityCreationActions.GET_VISIT_SURVEY_LIST_REQUEST }))())
        ProjectsService.GetVisitSurveyList(storeId)
            .then((res) => {
                dispatch(setVisitSurveyList(res.data?.surveys))
            })
            .finally(() =>
                dispatch(
                    (() => ({
                        type: NewActivityCreationActions.GET_VISIT_SURVEY_LIST_FINALLY,
                    }))()
                )
            )
    }
}

const activityTypeIconMap = {
    task: 'document-pencil',
    news: 'newspaper',
    visit: 'map-marker',
    challenge: 'star-fill',
}

export const getProjectsActivityTypes = ({
    dispatch,
    projectDetails,
    isEdit,
    isClone,
}: {
    dispatch: Dispatch<AnyAction>
    projectDetails: ProjectApiCreateActivityBody
    isEdit: boolean
    isClone: boolean
}) =>
    // newVersion: boolean
    {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        // Post integration
        // FiltersService.GetActivityTypes({newVersion})
        FiltersService.GetActivityTypes()
            .then((response) => {
                if (!!response?.data) {
                    dispatch(
                        setActivityType(
                            response.data.filterProjectTypes.map((type, index) => ({
                                key: type.projectTypeName,
                                active: !index,
                                icon: activityTypeIconMap[type.projectTypeName],
                                subTypes: type.subTypes.map((subType) => ({
                                    value: subType.projectSubTypeName,
                                    label: subType.moduleName,
                                    children: subType.children?.map((children) => ({
                                        value: children.childrenName,
                                        label: children.childrenName,
                                    })),
                                })),
                            }))
                        )
                    )
                    dispatch(layoutActions.setModals({ props: { loading: !!projectDetails?._id } }))
                    const defaultType =
                        response.data.filterProjectTypes?.length === 1
                            ? response.data.filterProjectTypes[0].projectTypeName
                            : LayoutActivityType.TASK
                    setActivityStatus(projectDetails.projectType || defaultType, true, true)

                    // Rifacciamo la chiamata altrimenti perdiamo le informazioni
                    // delle question all'interno dei jobs
                    if (projectDetails?._id) {
                        ProjectsService.GetProjectDetails(projectDetails?._id, [
                            projectDetails?.storesIdList[0],
                        ])
                            .then((res) => {
                                if (res && res.data) {
                                    setEditQuestionTask(
                                        res.data.storesList[0],
                                        res.data.jobs,
                                        isEdit,
                                        isClone,
                                        dispatch
                                    )
                                }
                            })
                            .finally(() => {
                                dispatch(layoutActions.setModals({ props: { loading: false } }))
                            })
                    }
                }
            })
            .catch(() => {
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }

export const setEditQuestionTask = (
    store: any,
    jobs: any[],
    isEdit: boolean,
    isClone: boolean,
    dispatch
) => {
    ;((store.jobsStores || [])[0]?.jobStore || []).forEach((task, index) => {
        let newJob: any = {
            title: task.title,
            description: task.details,
            urgent: task.priority === 'urgent',
            attachmentList: task.attachments
                ? task.attachments.map((attachment) => ({
                      _id: attachment._id,
                      file: attachment,
                      url: !!attachment && attachment.url,
                      hideEyeIcon: true,
                  }))
                : [],
            questionList: task.questions.map((question) => {
                let newQuestion: any = {
                    type: question.questionType,
                    text: question.questionTitle,
                    mandatoryAttachment: question.attachmentsRequired,
                    answerList: question.possibleAnswers.map((a) => ({
                        value: a,
                    })),
                    isDone: true,
                    attachmentList: question.attachments
                        ? question.attachments.map((attachment) => ({
                              _id: attachment._id,
                              file: attachment,
                              url: !!attachment && attachment.url,
                              hideEyeIcon: true,
                          }))
                        : [],
                }
                if (isEdit) newQuestion._id = question._id
                return newQuestion
            }),
            startDate: !isClone ? new Date(task.startDate) : null,
            endDate: !isClone ? new Date(task.endDate) : null,
            recipient: jobs[index].assignment,
            isDone: true,
        }
        if (isEdit) newJob._id = task._id
        dispatch(setTaskStatus(index, newJob))
    })
    ;((store.questionsStores || [])[0]?.questionStore || []).forEach((question, index) => {
        let newQuestion: any = {
            type: question.questionType,
            text: question.questionTitle,
            mandatoryAttachment: question.attachmentsRequired,
            answerList: question.possibleAnswers.map((a) => ({
                value: a,
            })),
            attachmentList: question.attachments
                ? question.attachments.map((attachment) => ({
                      _id: attachment._id,
                      file: attachment,
                      url: !!attachment && attachment.url,
                      hideEyeIcon: true,
                  }))
                : [],
            isDone: true,
        }
        if (isEdit) newQuestion._id = question._id
        dispatch(setQuestionStatus(index, newQuestion))
    })
}
